import Annotation from "./annotation";

class linesIndicator extends Annotation {
  constructor() {
    super();

    this.color = "#00b0f0";
    this.lineWidth = 1;
    this.space = 0.1;
    this.lineSpace = 0.04;
    this.canvasSize = null;
    this.numberOfLines = 5;
  }

  draw(ctx) {
    if (!this.canvasSize) 
      return;
    
      ctx.lineWidth = this.lineWidth;
      ctx.strokeStyle = this.color;
      ctx.fillStyle = this.color;
      
      let margin = this.canvasSize.w * this.space;
      let length = this.canvasSize.w - margin;
      
      let maxX = length;
      let minX = (this.canvasSize.w - length);

      let lineHight =  this.canvasSize.h * this.lineSpace;
      let middle = this.canvasSize.h / 2;
      let start = middle + (lineHight * this. numberOfLines / 2);


      for(var i = 0; i < this.numberOfLines; i++){
        ctx.beginPath();
        ctx.moveTo(minX, start);
        ctx.lineTo(maxX, start);
        ctx.stroke();
        ctx.closePath();
        start = start - lineHight;
      } 
  }

  updateNumberOfLines(lines){
    this.numberOfLines = lines;
    this.signalReady();
  }
}

export default linesIndicator;